/**
 * Sincroniza o estado visual dos selects nativos renderizados pelo cpa-grid legado com o
 * select2/jQuery, quando disponível (a maior parte do tempo cai no fallback nativo, já que
 * o bundle real da aplicação não carrega jQuery).
 */
export class CpaSelectSyncController {
  syncSelectVisualState(
    hostEl: HTMLElement | null | undefined,
    selectValueByTitle: Record<string, string>
  ): void {
    if (!hostEl) {
      return;
    }

    const selects = hostEl.querySelectorAll('select[bf-select2], select[data-bf-select2]');
    selects.forEach((selectEl) => {
      try {
        const labelEl = selectEl.previousElementSibling?.querySelector('span');
        const titulo = labelEl?.textContent?.trim() || '';
        const expectedValue = titulo ? selectValueByTitle[titulo] : undefined;

        const jq = (window as any).$ || (window as any).jQuery;
        if (typeof expectedValue === 'string') {
          (selectEl as HTMLSelectElement).value = expectedValue;
        }
        if (jq) {
          if (typeof expectedValue === 'string') {
            jq(selectEl).val(expectedValue);
          }
          jq(selectEl).trigger('change');
          jq(selectEl).trigger('change.select2');
        } else {
          selectEl.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } catch (e) {
        // Sincronização visual é best-effort — não bloqueia o resto do enhance
      }
    });
  }

  enhanceMultipleSelects(hostEl: HTMLElement | null | undefined): void {
    if (!hostEl) {
      return;
    }

    const jq = (window as any).$ || (window as any).jQuery;
    if (!jq || !jq.fn || typeof jq.fn.select2 !== 'function') {
      return;
    }

    const multiSelects = hostEl.querySelectorAll('select[multiple][bf-select2], select[multiple][data-bf-select2]');
    multiSelects.forEach((selectEl) => {
      try {
        const $select = jq(selectEl);
        if (!$select.hasClass('select2-offscreen')) {
          $select.select2({});
        }

        // Mantém o valor atual após inicialização do plugin.
        const values = Array.from((selectEl as HTMLSelectElement).selectedOptions).map((opt) => opt.value);
        if (values.length) {
          $select.val(values).trigger('change');
        }
      } catch (e) {
        // Inicialização do select2 é best-effort — não bloqueia os outros selects
      }
    });
  }
}
